import { assert_string_not_empty, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTOImageAiDescription extends DTO__database_entity {
  static _class_name_static: string = ENUM__dto_class_name.IMAGE_AI_DESCRIPTION;

  /*
   * FIELDS
   */
  user_id_creator!: string;
  image_id!: string;
  language!: string;
  description!: string;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_string_not_empty(this.user_id_creator);
    assert_string_not_empty(this.image_id);
    assert_type_enum(this.language, ENUM__language_type);
    assert_string_not_empty(this.description);
  }
}
